import { Immutable } from "immer";
import React from "react";
import SVG from "react-inlinesvg";

import iconGiftBox from "../../../../img/icons/gift-box.svg";
import { IReview } from "../../../models/reviews";
import { usePageSetting } from "../../../utils/settings";
import { ReviewDisclosureCode } from "../constants";

import styles from "./index.module.scss";

type IProps = Immutable<{
    review: IReview;
}>;

export const DisclosureCopy = (props: IProps): React.JSX.Element | null => {
    const disclosureSettings =
        usePageSetting("reviews_disclosures_settings") || {};
    const disclosureCopy = props.review.disclosure_code
        ? disclosureSettings[props.review.disclosure_code]
        : null;
    if (!disclosureCopy) {
        return null;
    }

    const className =
        props.review.disclosure_code === ReviewDisclosureCode.SAMPLING
            ? styles.rootAlt
            : styles.root;

    return (
        <div className={className}>
            {props.review.disclosure_code === ReviewDisclosureCode.SAMPLING && (
                <SVG aria-hidden="true" src={iconGiftBox} />
            )}
            {disclosureCopy}
        </div>
    );
};
